import React from "react";
import AttachMoney from "@mui/icons-material/AttachMoney";
import CalendarMonth from "@mui/icons-material/CalendarMonth";
import Flight from "@mui/icons-material/Flight";
import FlightLand from "@mui/icons-material/FlightLand";
import FlightTakeoff from "@mui/icons-material/FlightTakeoff";
import Groups from "@mui/icons-material/Groups";
import Hotel from "@mui/icons-material/Hotel";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Luggage from "@mui/icons-material/Luggage";
import PersonOutline from "@mui/icons-material/PersonOutline";
import Restaurant from "@mui/icons-material/Restaurant";
import RocketLaunch from "@mui/icons-material/RocketLaunch";
import StarBorder from "@mui/icons-material/StarBorder";
import ConfirmationNumber from "@mui/icons-material/ConfirmationNumber";

const iconSx = {
  fontSize: 16,
  flexShrink: 0,
  color: "#495057",
  marginTop: "2px",
};

/** מסיר אימוגי UI ישנים משורות היסטוריה (לפני התאמה לתווית). */
function stripLegacyLeadingEmojis(line) {
  let s = line;
  const emojiRun =
    /^(\s*•\s*)(?:🏨|📅|🗓️|🗓|✈️|✈|💰|💲|👤|👥|⭐|🛏️|🛏|🧳|🍽️|🍽|💬|🚀|👇|🖊|🖊️|💳)\s*/u;
  for (let i = 0; i < 3; i++) {
    const next = s.replace(emojiRun, "$1");
    if (next === s) break;
    s = next;
  }
  return s;
}

/** אימוג'ים בתחילת שורה (ללא נקודה) — הודעות ישנות / טקסט חיצוני. */
function stripLeadingLineEmojis(line) {
  let s = line;
  const atStart = /^\s*(?:🚀|✈️|✈|👤|👥|👇|🖊|🖊️|💳)+\s*/u;
  for (let i = 0; i < 3; i++) {
    const next = s.replace(atStart, "");
    if (next === s) break;
    s = next;
  }
  return s;
}

function trimmedAfterBullet(line) {
  let s = stripLeadingLineEmojis(line);
  s = stripLegacyLeadingEmojis(s);
  return s.replace(/^\s*•\s*/, "").trimStart();
}

function pickIconForLine(trimmed) {
  if (!trimmed) return null;
  if (trimmed.startsWith("אנחנו ממש בשלב האחרון")) return RocketLaunch;
  if (trimmed.startsWith("החופשה שלך כמעט")) return Flight;
  if (trimmed.startsWith("הנוסעים:")) return Groups;
  if (trimmed.startsWith("שמרנו את פרטי הנוסעים")) return Groups;
  if (trimmed.startsWith("מבוגר:")) return PersonOutline;
  if (trimmed.startsWith("ילד:")) return PersonOutline;
  if (trimmed.startsWith("תינוק:")) return PersonOutline;
  if (trimmed.startsWith("בוא נסגור") || trimmed.startsWith("בואו נסגור"))
    return KeyboardArrowDown;
  if (trimmed.startsWith("מלון:")) return Hotel;
  if (trimmed.startsWith("דירוג:")) return StarBorder;
  if (trimmed.startsWith("חדר:")) return Hotel;
  if (trimmed.startsWith("בסיס אירוח:")) return Restaurant;
  if (trimmed.startsWith("תאריכים:")) return CalendarMonth;
  if (trimmed.startsWith("כן נמצאו תוצאות בחודשים הבאים:"))
    return CalendarMonth;
  if (trimmed.startsWith("הלוך:")) return FlightTakeoff;
  if (trimmed.startsWith("חזור:")) return FlightLand;
  if (trimmed.startsWith("חברת תעופה:")) return Flight;
  if (trimmed.startsWith("מספרי טיסות:")) return ConfirmationNumber;
  if (trimmed.startsWith("כבודה:")) return Luggage;
  if (trimmed.startsWith("מחיר כולל:")) return AttachMoney;
  if (trimmed.startsWith("סכום:")) return AttachMoney;
  return null;
}

function AssistantLine({ line }) {
  if (!line.trim()) {
    return <div className="hr-cvac-assistant-text__spacer" aria-hidden />;
  }
  const trimmed = trimmedAfterBullet(line);
  const Icon = pickIconForLine(trimmed);
  const display = stripLeadingLineEmojis(stripLegacyLeadingEmojis(line)).trimEnd();

  if (!Icon) {
    return (
      <p className="hr-cvac-assistant-text__plain">
        {display}
      </p>
    );
  }

  return (
    <div className="hr-cvac-assistant-text__line">
      <Icon className="hr-cvac-assistant-text__icon" sx={iconSx} aria-hidden />
      <span className="hr-cvac-assistant-text__line-text">{trimmed}</span>
    </div>
  );
}

/**
 * תוכן הודעת עוזר בצ'אט חבילות — אייקונים מקצועיים במקום אימוגים.
 */
export default function CustomerVacationChatAssistantText({ text }) {
  const raw = String(text ?? "");
  const lines = raw.split("\n");
  return (
    <div className="hr-cvac-assistant-text" dir="rtl">
      {lines.map((line, i) => (
        <AssistantLine key={`${i}-${line.slice(0, 24)}`} line={line} />
      ))}
    </div>
  );
}
